import { Reducer } from 'redux';

import { IPersonsState } from 'types/persons.types';
import * as authConstants from 'redux/constants/auth.constants';
import * as constants from 'redux/constants/persons.constants';

export const defaultState: IPersonsState = {
  cementeries: {},
  civilStates: {},
  count: 0,
  idCardTypes: {},
  items: [],
  loading: false,
  personStates: {},
  selectedItem: null,
  table: {
    page: 1,
    limit: 10,
    search: '',
    sortKey: 'firstName',
    sortType: 'asc',
  },
  tribes: {},
};

const personsReducer: Reducer = (state = defaultState, action) => {
  const { data, type } = action;
  switch (type) {
    case constants.PERSONS_ON_DELETE_REQUESTED:
    case constants.PERSONS_ON_GET_ALL_REQUESTED:
    case constants.PERSONS_ON_GET_FORM_REQUESTED:
    case constants.PERSONS_ON_SAVE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case constants.PERSONS_ON_GET_ONE_REQUESTED:
      return {
        ...state,
        loading: !!action.id,
        selectedItem: null,
      };
    case constants.PERSONS_ON_GET_ALL_SUCCEEDED:
      return {
        ...state,
        count: data.count,
        items: data.items,
        loading: false,
        table: data.table,
      };
    case constants.PERSONS_ON_GET_FORM_SUCCEEDED:
      return {
        ...state,
        cementeries: data.cementeries,
        civilStates: data.civilStates,
        idCardTypes: data.idCardTypes,
        loading: false,
        personStates: data.personStates,
        tribes: data.tribes,
      };
    case constants.PERSONS_ON_GET_ONE_SUCCEEDED:
      return {
        ...state,
        loading: false,
        selectedItem: data.item,
      };
    case constants.PERSONS_ON_DELETE_SUCCEEDED:
    case constants.PERSONS_ON_SAVE_SUCCEEDED:
    case constants.PERSONS_ON_DELETE_FAILED:
    case constants.PERSONS_ON_GET_ALL_FAILED:
    case constants.PERSONS_ON_SAVE_FAILED:
      return {
        ...state,
        loading: false,
      };
    case constants.PERSONS_ON_GET_FORM_FAILED:
      return {
        ...state,
        cementeries: {},
        civilStates: {},
        idCardTypes: {},
        loading: false,
        personStates: {},
        tribes: {},
      };
    case constants.PERSONS_ON_GET_ONE_FAILED:
      return {
        ...state,
        loading: false,
        selectedItem: null,
      };
    case authConstants.AUTH_ON_LOGOUT_SUCCEEDED:
    case authConstants.AUTH_ON_LOGOUT_PUBLIC_SUCCEEDED:
      return defaultState;
    default:
      return state;
  }
};

export default personsReducer;
